import { paramsFromUrlGet } from '@components/Utility/UrlParser.js';
import { ReplaySubject, take } from 'rxjs';
import DIContainer from '@components/DependencyInjectionContainer.js';
import { BaseClass } from '@components/BaseClass.js';
import { ENV } from '@components/Environment.js';
/**
 * ScreenRouter is registered in commonDependencies.ts
 */
/**
 * `ScreenRouter` is a utility class used by `Screen` to interpret routes and load the appropriate `Form`.
 */
export class ScreenRouter extends BaseClass {
    /**
     * Utility class to load form assets when the screen URL changes
     * @private
     */
    get FormLoader() {
        // if (!this.dependencies.FormLoader) {
        // 	this.dependencies.FormLoader = DIContainer.getInstance('FormLoader');
        // }
        // return this.dependencies.FormLoader;
        return DIContainer.getInstance('FormLoader');
    }
    constructor() {
        super();
        this.routes = new Map();
        this.dynamicRoutes = ENV('dynamicRoutes');
        this.addRoute({ path: 'error', componentName: 'ErrorForm' });
    }
    /**
     * define a route for static pages
     * @param route
     */
    addRoute(route) {
        this.routes.set(route.path, route);
    }
    /**
     * remove a route
     * @param path
     */
    removeRoute(path) {
        this.routes.delete(path);
    }
    hasRoute(path) {
        return this.routes.has(path);
    }
    /**
     * Interprets a route and returns an observable that will emit a `Form` once the form is created.
     * @param url
     * @param parameters
     * @param options
     */
    loadRoute$(url, parameters, options) {
        let { pathname, params, formname, hash } = paramsFromUrlGet(url);
        if (parameters) {
            // params passed in explicitly will override the url. 
            parameters = { ...params, ...parameters };
        }
        else {
            parameters = params;
        }
        const formSubject = new ReplaySubject(1);
        let routeInfo = this.routes.get(formname);
        if (!routeInfo && !this.dynamicRoutes) {
            routeInfo = this.routes.get('*');
            // TODO: we currently do not support the "default" catch all route being database driven.
            // Currently not an issue, as eaccept and login only have default routes and they use framework forms.
            formname = '';
        }
        if (routeInfo && routeInfo.formName) {
            formname = routeInfo.formName;
        }
        hash = hash || options?.hash;
        if (hash) {
            options = options || {};
            options.hash = hash;
        }
        if (routeInfo?.handleRoute) {
            return routeInfo.handleRoute(pathname, parameters);
        }
        else if (routeInfo && routeInfo.componentName && routeInfo.componentName !== 'FormLoader') {
            DIContainer.resolveLazy(routeInfo.componentName)
                .subscribe((form) => {
                form.formName = formname;
                form.refreshData(parameters)
                    .subscribe(() => {
                    if (hash) {
                        form.setTabFromHash(hash);
                    }
                });
                formSubject.next(form);
            });
        }
        else if (formname && this.dynamicRoutes || routeInfo?.componentName === 'FormLoader') {
            // if this application allows dynamicRoutes or if this route is mapped to the database FormLoader
            return this.FormLoader.formLoad$(formname, parameters, options);
        }
        else {
            formSubject.error(`Form not found: ${formname}`);
        }
        return formSubject.asObservable().pipe(take(1));
    }
}
